export default ({ data }) => {
    return (
        <div className="d-flex mb-2">
            <div style={{ width: "100px", height: "60px" }}>
                <img src={data.image} className="w-100 h-100 rounded" />
            </div>
            <div className="d-flex flex-column ms-2">
                <p className="bold mb-0">{ data.name }</p>
                <p>{data.description}</p>
            </div>
        </div>
    )
}